import ListingFacets from './ListingFacets'

export default ListingFacets
